export default __webpack_public_path__ + "static/covid-care-service-help-line-img-5065edf23f745f60bf5faaf526908aa1.png";